import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TraineeListService } from "../../service/trainee-list.service";
import { RoleplayApiService } from "../../service/roleplay.service";
import { DateFormateService } from "../../date-formate.service";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateSourceComponent } from "../create-source/create-source.component";
import { InteractionService } from '../../service/interaction/interaction.service';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { ChatService } from '../../service/chat-service';
import {PlatformRegionService} from '../../../app/service/shared/platform-region.service';

@Component({
    selector: 'app-amp-data-source-list',
    templateUrl: './amp-data-source-list.component.html',
    styleUrl: './amp-data-source-list.component.scss',
    standalone: false
})
export class AmpDataSourceListComponent {
 @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  showNoSearchResultsMessage: boolean = false;
  // displayedColumns: string[] = ['amp_adptr_created_at','amp_status', 'asset_type', 'cdn_url', 'embedding_proc_status', 'error_desc', 'expiration_date', 'id', 'language', 'modifiedon', 'primary_market_approved_for', 'primary_platform_category', 'source_file', 'status', 'status_readonly', 'title'];
  displayedColumns: string[] = ['source_file', 'asset_type', 'amp_adptr_created_at', 'expiration_date', 'modifiedon'];
  filterValue: string;
  // dataSource:any= [];
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');
  dataCount: number = 0;
  dataSource:any = new MatTableDataSource();
  selectedSourceName = null;
  filterForm: FormGroup;
  dataSourceFromAPI = [];
  dataSourceArr: any;
 
  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, public roleplayservice: RoleplayApiService,private dateFormatService: DateFormateService, 
    public dialog: MatDialog, private fb: FormBuilder, public ChatService: ChatService,private PlatformRegionService: PlatformRegionService,
  private readonly intService: InteractionService) {
    this.intService.refreshHeader$.subscribe(() => {
      this.business_unit_code = sessionStorage.getItem('businessUnitCode')
    });
  }
  ngOnInit(){
      this.filterForm = this.fb.group({
        searchInput: new FormControl(''),
      });
    this.getDocumentList();
    this.datasourceCode();
}
datasourceCode() {
  this.dataSourceArr = [];
  let business_unit_code = sessionStorage.getItem('businessUnitCode');
  if (business_unit_code !== "") {
    this.ChatService.datasourceCode(business_unit_code).subscribe(
      (res) => {
        if (res && res.length > 0) {
          res.map(item => {
            this.dataSourceArr.push(item.source_name);
          });
        } else {
          this.dataSourceArr = [];
        }
      });
  }
}

getDocumentList () {
  this.showLoader();
  let business_unit_code =  sessionStorage.getItem('businessUnitCode');
  const region_name = this.PlatformRegionService.selectedRegion.name || '';
  this.roleplayservice.getAMPDataSourceList(business_unit_code, region_name).subscribe(res=>{
  this.hideLoader();
  this.dataSourceFromAPI = res;
    this.dataCount = res.length;
    this.dataSource=new MatTableDataSource(res);
    this.dataSource.paginator= this.paginator;
  
  });
}

convertUtcToLocal(utcDateString: string): Date | null {
  if (!utcDateString) return null;
  const utcDate = utcDateString.split('.')[0] + 'Z';
  return new Date(utcDate);
}
  userinfo(wwid: number) {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: wwid} });
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Handle midnight
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  
    // Format as "dd:mm:yyyy hh:mm tt"
    const formattedDate = `${this.padZero(date.getDate())}:${this.padZero(date.getMonth() + 1)}:${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;
  
    return formattedDate;
  }
  // createSource(){
  //   this.Router.navigate(['/app-create-source'], {skipLocationChange: true});
  // }
  showDetails(row){
  this.showLoader();
    this.selectedSourceName = row.source_file;
    this.roleplayservice.getAMPDataSourceListBySourceFile(row.source_file).subscribe(res=>{
  this.hideLoader();
  this.dataSourceFromAPI = res;
  this.filterForm.controls['searchInput'].setValue("");
      // res.sort((a, b) => b.source_file - a.source_file);
      this.dataSource=new MatTableDataSource(res);
      this.dataSource.paginator= this.paginator;    
    });
  }

  backButton(){
    this.selectedSourceName = null
    this.filterForm.controls['searchInput'].setValue("");
    this.getDocumentList();
  }

  goToLink(url: string){
    window.open(url, "_blank");
}
  
  // Function to pad zeros for single-digit day or month
  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
     // Check if there are any items after applying the filter
     if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }
 
  // openCreateSourceDialog() {
  //   const dialogRef = this.dialog.open(CreateSourceComponent, {
  //     width: '450px', // Specify the width of the dialog
  //     data: {} // You can pass data to the dialog if necessary
  //   });
  
  //   // Optionally, handle the dialog close event
  //   dialogRef.afterClosed().subscribe(result => {
  //     // Perform any actions after the dialog is closed
  //     // console.log('The dialog was closed', result);
  //     this.getDocumentList()
  //   });
  // }
  docbutton(){
    this.Router.navigate(["/app-document-list"], { skipLocationChange: true });
  }
  sortData(sort: Sort) {
    const data = this.dataSourceFromAPI.slice();
    if (!sort.active || sort.direction === '') {
      // this.sortedData = data;
      this.dataSource=new MatTableDataSource(data);
      this.dataSource.paginator= this.paginator;
      return;
    }

    this.dataSource = new MatTableDataSource(data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'source_file':
          return this.compare(a.source_file, b.source_file, isAsc);
        case 'asset_type':
          return this.compare(a.asset_type, b.asset_type, isAsc);
        case 'amp_adptr_created_at':
          return this.compare(a.amp_adptr_created_at, b.amp_adptr_created_at, isAsc);
        case 'expiration_date':
          return this.compare(a.expiration_date, b.expiration_date, isAsc);
        case 'modifiedon':
          return this.compare(a.modifiedon, b.modifiedon, isAsc);
        case 'cdn_url':
          return this.compare(a.cdn_url, b.cdn_url, isAsc);
        default:
          return 0;
      }
    }));

    this.dataSource.paginator= this.paginator;
  }


compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

  
  showLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'inline-block';
  }
  
  hideLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
  }
 
}
